import React, { FC } from 'react';

export const XIcon: FC<{ className?: string; href?: string }> = (props) => {
  return (
    <a className={props.className} href={props.href}>
      <svg width="18" height="14" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 1.75c-.662.282-1.374.379-2.12.463.658-.481.995-.645 1.52-1.63-.713.405-1.402.375-2.242.534A3.77 3.77 0 0 0 12.463 0c-2.04 0-3.695 1.583-3.695 3.534 0 .277.033.547.097.806A10.829 10.829 0 0 1 1.2.583C.883 1.105.753 1.776.753 2.424c0 1.226.653 2.307 1.644 2.942a3.806 3.806 0 0 1-1.673-.442v.044c0 1.712 1.272 3.14 2.962 3.466a3.848 3.848 0 0 1-1.668.06c.47 1.404 1.767 2.56 3.382 2.59C3.825 12.814.29 12.281 0 12.25 1.636 13.252 3.577 14 5.662 14c6.792 0 10.506-5.385 10.506-10.055 0-.153-.003-.307-.01-.457.72-.498 1.347-1.028 1.842-1.738"
          fill="#BEBEBE"
          fillRule="evenodd"
        ></path>
      </svg>
    </a>
  );
};
